// extracted by mini-css-extract-plugin
export default {"screenCardNameInput":"YDagbyZS2h3ak_QLr4uj","textArea":"SEDrd9sufqEC9Qj_HZxb"};